import { addHours, getMinutes, setMinutes } from 'date-fns'

export const getRoundedExpirationTime = (date: Date, hoursToAdd = 2): Date => {
  const newDate = addHours(date, hoursToAdd)
  const roundedMinutes = Math.ceil(getMinutes(newDate) / 10) * 10
  return setMinutes(newDate, roundedMinutes === 60 ? 0 : roundedMinutes)
}
